import { WORK_EXPERIENCE_INFO } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(WORK_EXPERIENCE_INFO)
